module.exports = __webpack_public_path__ + "img/loading-img.c1665640.png";